// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4938":"27fe1ea9","5454":"7ec9664c","7815":"c35b4248","9292":"aa92aa3b","9879":"aa92aa3b"}[chunkId] + ".chunk.css";
};